/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Extra_Session_Buy_MonthInputs */

const fr_extra_session_buy_month = /** @type {(inputs: Extra_Session_Buy_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Acheter un cours supplémentaire (${i?.price})`)
};

/**

* @param {Extra_Session_Buy_MonthInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_buy_month = /** @type {((inputs: Extra_Session_Buy_MonthInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Buy_MonthInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_buy_month(inputs)
});